import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
  FETCH_ALLOWED_MODULES_REQUEST,
  FETCH_ALLOWED_MODULES_SUCCESS,
  FETCH_ALLOWED_MODULES_FAILURE,
} from "./actionTypes"

export const fetchAllowedModulesRequest = () => ({
  type: FETCH_ALLOWED_MODULES_REQUEST,
})

export const fetchAllowedModulesSuccess = modules => ({
  type: FETCH_ALLOWED_MODULES_SUCCESS,
  payload: modules,
})

export const fetchAllowedModulesFailure = error => ({
  type: FETCH_ALLOWED_MODULES_FAILURE,
  payload: error,
})

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const socialLogin = (type, history) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { type, history },
  }
}
